import { Controller } from '@hotwired/stimulus';

import { driver } from 'driver.js';

export default class extends Controller {
  static targets = [
    'step1',
    'step2',
    'step3',
    'step4',
    'step5',
    'step6',
    'step7',
  ];

  static values = {
    skip: String,
    back: String,
    next: String,
    finish: String,
    title: String,
  };

  start() {
    this.systemCheckboxAll.checked = false;
    this.systemCheckboxAll.dispatchEvent(new Event('input'));
    this.systemCheckboxBazi.checked = true;
    this.systemCheckboxBazi.dispatchEvent(new Event('input'));
    this.systemCheckboxElements.checked = true;
    this.systemCheckboxElements.dispatchEvent(new Event('input'));
    this.systemCheckboxHiddenStems.checked = false;
    this.systemCheckboxHiddenStems.dispatchEvent(new Event('input'));

    this.driverObj = driver({
      showProgress: true,
      nextBtnText: this.nextValue,
      prevBtnText: this.backValue,
      doneBtnText: this.finishValue,

      overlayColor: '#555',
      popoverClass: 'driverjs-theme',

      steps: [
        {
          element: this.step1Target,

          popover: {
            title: this.titleValue,
            description: this.step1Target.dataset.tourRomanticSelfStep1Text,
          },
        },

        {
          element: this.step2Target,

          popover: {
            title: this.titleValue,
            description: this.step2Target.dataset.tourRomanticSelfStep2Text,
          },
        },

        {
          element: this.step3Target,

          popover: {
            title: this.titleValue,
            description: this.step3Target.dataset.tourRomanticSelfStep3Text,
          },
        },

        {
          element: this.step4Target,

          popover: {
            title: this.titleValue,
            description: this.step4Target.dataset.tourRomanticSelfStep4Text,
          },
        },

        {
          element: this.step5Target,

          popover: {
            title: this.titleValue,
            description: this.step5Target.dataset.tourRomanticSelfStep5Text,
          },
        },

        {
          element: this.step6Target,

          popover: {
            title: this.titleValue,
            description: this.step6Target.dataset.tourRomanticSelfStep6Text,
          },
        },

        {
          element: this.step7Target,

          popover: {
            title: this.titleValue,
            description: this.step7Target.dataset.tourRomanticSelfStep7Text,
          },
        },
      ],
    });

    this.driverObj.drive();
  }

  disconnect() {
    this.driverObj?.destroy();
  }

  showSystemDropdown() {
    this.systemDropdownController.show();
  }

  hideSystemDropdown() {
    this.systemDropdownController.close();
  }

  get systemDropdownController() {
    return this.application.getControllerForElementAndIdentifier(
      this.systemDropdownTarget,
      'dropdown',
    );
  }

  get systemCheckboxAll() {
    return document.querySelector("[data-filter='all']");
  }

  get systemCheckboxElements() {
    return document.querySelector("[data-filter='elements']");
  }

  get systemCheckboxHiddenStems() {
    return document.querySelector("[data-filter='hidden_stems']");
  }

  get systemCheckboxBazi() {
    return document.querySelector("[data-filter='bazi']");
  }
}
